// @todo: Migrate to @wandb/components. For more details see:
// https://www.notion.so/wandbai/Migrating-components-207e2f5c7ef380129201f72a5770a8db
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button, ButtonSizes, ButtonVariants} from '@wandb/weave/components';
import React from 'react';

import {MediaBrowserPanelConfig} from '../../../../PanelMediaBrowser/common';
import {useMediaSettingsDrawerContext} from '../MediaSettingsDrawerContextProvider';

export const SettingTitle: React.FC<{
  title: string;
  id?: string;
  description?: string;
  tooltip?: string;
  unsetConfigField?: () => void;
  configField: keyof MediaBrowserPanelConfig;
}> = ({title, id, description, tooltip, unsetConfigField, configField}) => {
  const {configWithoutDefaults} = useMediaSettingsDrawerContext();
  return (
    <div className="mb-2 flex flex-col">
      <div className="flex items-center justify-between">
        <div className="flex gap-4" id={id}>
          <div className="pb-2 font-semibold">{title}</div>
          {tooltip && (
            <Button
              size="small"
              variant="ghost"
              icon="info"
              tooltipProps={{className: 'w-[20rem]'}}
              tooltip={tooltip}
            />
          )}
        </div>
        {configWithoutDefaults[configField] != null && unsetConfigField && (
          <Button
            aria-label="Reset to parent"
            icon="randomize-reset-reload"
            onClick={unsetConfigField}
            size={ButtonSizes.Medium}
            tooltip="Reset to parent"
            variant={ButtonVariants.Ghost}
            data-test={`reset-to-parent-${configField}`}
          />
        )}
      </div>
      {description && (
        <div className="pt-2 text-sm text-moon-600">{description}</div>
      )}
    </div>
  );
};
